import * as GQL from './graphql-types';
import PossibleTypes from './possible-types';

export const possibleTypes = PossibleTypes.possibleTypes;
export { GQL };
